export const siteConfig = {
  name: "Suhas Sunder",
  title: "Engineering Portfolio",
  description:
    "Engineering portfolio of Suhas Sunder, Engineer-in-Training registered with Engineers and Geoscientists BC, featuring engineering analysis, systems modelling, technical projects, project delivery, and professional technical experience.",
  url: "https://suhassunder.ca",
  email: "suhas@live.ca",
  phoneDisplay: "(647) 242-2969",
  phoneHref: "tel:+16472422969",
  linkedIn: "https://linkedin.com/in/s-sunder",
  location: "Toronto, ON, Canada",
  mobility: "Open to relocation across Canada & the U.S.",
  availability:
    "Open to relocation across Canada & the U.S. | Open to travel | On-site & hybrid",
  driverLicence: "Valid Canadian driver's licence",

  resumeUrl:
    "https://drive.google.com/file/d/101xfA7D03hnIUp9I5E8pJR_HuW9D_rjf/view?usp=drive_link",
};
